export default {
    LOAD_SCENES: 'loadScenes'
};